import { render, staticRenderFns } from "./importTestingCenter.vue?vue&type=template&id=09247f32&"
import script from "./importTestingCenter.vue?vue&type=script&lang=js&"
export * from "./importTestingCenter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports